import React from "react";

const RefundPolicy = () => {
  return (
    <div className="bg-[#fcf3f8] text-[#4b2b1b]">
      <div className="container mx-auto px-6 py-12 max-w-4xl">

        <h1 className="text-3xl font-bold mb-8 text-center">
          Return & Refund Policy
        </h1>

        <div className="space-y-4 text-lg leading-relaxed font-medium">

          <p>• No refund /replacement /cancellation of orders placed.</p>

          <p>• In case of any missing or defective or wrong product received, opening video will be a must.</p>

          <p>• Opening video , with centre camera focus on the box/ parcel , should be from starting to end of unboxing your parcel without any pauses or breaks.</p>

          <p>• We will then closely analyse the video and initiate the needful process.</p>

          <p>• No complaint will be entertained without the video.</p>

        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
